(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faenza-kit-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faenza-kit-gallery')) {
    customElements.define('faenza-kit-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        const thumbnails = Array.from(this.querySelectorAll('[data-gallery-index]'));
        const strip = this.querySelector('[data-gallery-thumbnails]');
        const stage = this.querySelector('[data-gallery-stage]');
        const current = this.querySelector('[data-gallery-current]');
        if (!slides.length) return;
        let index = 0;
        const show = (next) => {
          index = (next + slides.length) % slides.length;
          slides.forEach((slide, i) => { slide.hidden = i !== index; });
          thumbnails.forEach((thumbnail, i) => {
            thumbnail.setAttribute('aria-pressed', String(i === index));
          });
          current.textContent = String(index + 1);
          const active = thumbnails[index];
          const activeBox = active.getBoundingClientRect();
          const stripBox = strip.getBoundingClientRect();
          if (activeBox.left < stripBox.left || activeBox.right > stripBox.right) {
            strip.scrollLeft += activeBox.left - stripBox.left - (strip.clientWidth - active.offsetWidth) / 2;
          }
        };
        thumbnails.forEach((thumbnail, i) => {
          thumbnail.addEventListener('click', () => show(i));
        });
        this.querySelector('[data-gallery-previous]').addEventListener('click', () => show(index - 1));
        this.querySelector('[data-gallery-next]').addEventListener('click', () => show(index + 1));
        this.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1);
          show(next);
          if (event.target.matches('[data-gallery-index]')) thumbnails[index].focus({ preventScroll: true });
        });
        let pointerStart = null;
        stage.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' || !event.isPrimary) return;
          pointerStart = { x: event.clientX, y: event.clientY };
        });
        stage.addEventListener('pointerup', (event) => {
          if (!pointerStart) return;
          const dx = event.clientX - pointerStart.x;
          const dy = event.clientY - pointerStart.y;
          pointerStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) show(index + (dx < 0 ? 1 : -1));
        });
        stage.addEventListener('pointercancel', () => { pointerStart = null; });
        this.querySelector('[data-gallery-controls]').hidden = false;
        strip.hidden = false;
      }
    });
  }
  if (!customElements.get('faenza-kit')) {
    customElements.define('faenza-kit', class extends HTMLElement {
      connectedCallback() {
        this.unsubscribeCartUpdate?.();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.resetPurchaseError());
        }
        this.cartObserver?.disconnect();
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          this.cartObserver = new MutationObserver(() => this.resetPurchaseError());
          this.cartObserver.observe(cartDrawer, { childList: true });
        }
        this.purchaseObserver?.disconnect();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton) {
          this.purchaseObserver = new MutationObserver(() => this.restorePurchaseButton());
          this.purchaseObserver.observe(submitButton, { attributes: true, attributeFilter: ['class', 'disabled'] });
          this.restorePurchaseButton();
        }
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.querySelector('form')?.addEventListener('submit', () => {
          const productForm = this.querySelector('product-form');
          if (productForm && !productForm.submitButton?.classList.contains('loading')) productForm.error = false;
        }, { capture: true });
        const quantity = this.querySelector('[name="quantity"]');
        quantity?.addEventListener('change', () => this.resetPurchaseError());
        const changeQuantity = (delta) => {
          if (!quantity) return;
          const max = quantity.max ? Number(quantity.max) : Infinity;
          quantity.value = String(Math.min(max, Math.max(1, (Number(quantity.value) || 1) + delta)));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        };
        this.querySelector('[data-kit-minus]')?.addEventListener('click', () => changeQuantity(-1));
        this.querySelector('[data-kit-plus]')?.addEventListener('click', () => changeQuantity(1));
      }
      disconnectedCallback() {
        this.unsubscribeCartUpdate?.();
        this.cartObserver?.disconnect();
        this.purchaseObserver?.disconnect();
      }
      restorePurchaseButton() {
        const productForm = this.querySelector('product-form');
        const button = productForm?.querySelector('[type="submit"]');
        if (productForm?.error && productForm.dataset.kitAvailable === 'true' && button?.disabled && !button.classList.contains('loading')) {
          button.removeAttribute('disabled');
        }
      }
      resetPurchaseError() {
        const productForm = this.querySelector('product-form');
        if (!productForm?.error || productForm.submitButton?.classList.contains('loading')) return;
        productForm.error = false;
        productForm.handleErrorMessage();
        if (productForm.dataset.kitAvailable === 'true') {
          productForm.submitButton.removeAttribute('disabled');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faenza-wholesale-registration"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faenza-wholesale-form')) {
    customElements.define('faenza-wholesale-form', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.fieldset = this.querySelector('fieldset');
        this.button = this.querySelector('[type="submit"]');
        this.error = this.querySelector('.fwr__error');
        this.status = this.querySelector('.fwr__status');
        this.fallback = this.querySelector('.fwr__fallback');
        this.success = this.querySelector('.fwr__success');
        this.buttonText = this.button.textContent;
        this.form.addEventListener('input', event => {
          if (event.target.setCustomValidity) {
            event.target.setCustomValidity('');
            event.target.removeAttribute('aria-invalid');
          }
        });
        this.form.addEventListener('submit', event => this.submit(event));
        this.fieldset.disabled = false;
      }

      async submit(event) {
        event.preventDefault();
        if (this.pending || this.completed) return;
        this.error.hidden = true;
        this.fallback.hidden = true;
        const fields = ['firstname', 'phone', 'email', 'company', 'faenza_inversion', 'message'];
        const values = {};
        for (const name of fields) {
          const input = this.form.elements.namedItem(name);
          input.value = input.value.trim();
          input.setCustomValidity('');
          if (input.required && !input.value) input.setCustomValidity(this.dataset.requiredError);
          values[name] = input.value;
        }
        const phone = this.form.elements.namedItem('phone');
        let normalizedPhone = values.phone.replace(/[\s().-]/g, '');
        if (/^\d{8}$/.test(normalizedPhone)) normalizedPhone = '+502' + normalizedPhone;
        if (/^502\d{8}$/.test(normalizedPhone)) normalizedPhone = '+' + normalizedPhone;
        if (!/^\+[1-9]\d{7,14}$/.test(normalizedPhone)) phone.setCustomValidity(this.dataset.phoneError);
        if (!this.form.reportValidity()) return;
        if (this.form.elements.namedItem('fwr_website').value) return;
        values.phone = normalizedPhone;
        values.faenza_inversion = String(this.form.elements.namedItem('faenza_inversion').valueAsNumber);
        const body = {
          fields: fields.filter(name => values[name]).map(name => ({objectTypeId: '0-1', name, value: values[name]})),
          context: {pageUri: location.origin + location.pathname, pageName: document.title}
        };
        this.pending = true;
        this.fieldset.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        this.button.textContent = this.dataset.sending;
        this.status.textContent = this.dataset.sending;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 25000);
        try {
          const response = await fetch(this.dataset.endpoint, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            credentials: 'omit',
            body: JSON.stringify(body),
            signal: controller.signal
          });
          if (!response.ok) {
            let result = {};
            try { result = await response.json(); } catch (_) {}
            const emailError = result.errors?.some(error => /EMAIL/.test(error.errorType || ''));
            if (emailError) {
              this.form.elements.namedItem('email').setAttribute('aria-invalid', 'true');
              throw new Error(this.dataset.emailError);
            }
            throw new Error(response.status === 429 ? this.dataset.rateError : this.dataset.error);
          }
          this.completed = true;
          this.form.hidden = true;
          this.success.hidden = false;
          this.success.focus();
        } catch (error) {
          this.error.textContent = error.message === this.dataset.emailError || error.message === this.dataset.rateError ? error.message : this.dataset.error;
          this.error.hidden = false;
          this.fallback.hidden = false;
        } finally {
          clearTimeout(timeout);
          this.pending = false;
          this.fieldset.disabled = this.completed === true;
          this.form.removeAttribute('aria-busy');
          this.button.textContent = this.buttonText;
          this.status.textContent = '';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
if (!customElements.get('faenza-launch')) {
  customElements.define('faenza-launch', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('.launch-dialog');
      this.openButton = this.querySelector('[data-launch-open]');
      this.openButton.addEventListener('click', () => this.dialog.showModal(), options);
      this.querySelector('[data-launch-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.openButton.focus(), options);
      if (this.querySelector('[data-launch-password-error]')) this.dialog.showModal();
      const date = this.dataset.launchDate;
      const time = this.dataset.launchTime;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) return;
      const target = new Date(`${date}T${time}:00-06:00`).getTime();
      if (!Number.isFinite(target)) return;
      if (new Date(target - 21600000).toISOString().slice(0, 10) !== date) return;
      this.target = target;
      this.parts = ['days', 'hours', 'minutes', 'seconds'].map(part => this.querySelector(`[data-launch-${part}]`));
      this.querySelector('[data-launch-clock-note]').hidden = true;
      this.querySelector('[data-launch-soon]').hidden = true;
      this.querySelector('[data-launch-soon-label]').hidden = true;
      if (this.updateClock()) this.interval = setInterval(() => this.updateClock(), 1000);
    }
    updateClock() {
      const remaining = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
      if (remaining <= 0) {
        this.querySelector('[data-launch-countdown]').hidden = true;
        this.querySelector('[data-launch-countdown-label]').hidden = true;
        this.querySelector('[data-launch-expired]').hidden = false;
        this.querySelector('[data-launch-soon-label]').hidden = false;
        clearInterval(this.interval);
        return false;
      }
      const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
      values.forEach((value, index) => { this.parts[index].textContent = String(value).padStart(2, '0'); });
      this.querySelector('[data-launch-countdown]').hidden = false;
      this.querySelector('[data-launch-countdown-label]').hidden = false;
      return true;
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
